module.exports = __webpack_public_path__ + "static/willBaxter-665e8dcdbe3cdeb35dffd3b385b063db.jpg";